function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b_0_39)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 18,
  fill: "url(#paint0_linear_0_39)",
  fillOpacity: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 17.5,
  stroke: "#1F2937"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.375 13.5001H9V15.7501H28.125L21.375 9V13.5001ZM14.625 22.4999H27V20.2499H7.875L14.625 27V22.4999Z",
  fill: "url(#paint1_linear_0_39)"
});
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b_0_39",
  x: -42,
  y: -42,
  width: 120,
  height: 120,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 21
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_0_39"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_0_39",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_0_39",
  x1: 0,
  y1: 0,
  x2: 22.0093,
  y2: 43.1381,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_0_39",
  x1: 7.875,
  y1: 18,
  x2: 28.1247,
  y2: 17.9231,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#415FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})));
function SvgSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switchIcon.7d6b7df0c9c01140d03032c8753eb447.svg";
export { ForwardRef as ReactComponent };